export type AnalyzePresentation = "modal" | "panel";

export const SCAN_STEP_INTERVAL_MS = 1200;

export const SHARE_PERMISSIONS_TOOLTIP =
  "Share link & who can view — opens Summary → Share & Permissions";

/** Readable text selection on dark Analyze surfaces. */
export const ANALYZE_SELECTION_CLASSES = "selection:bg-primary/35 selection:text-foreground";

export const ANALYZE_INSIGHT_RENDERER_CLASS =
  "prose-code:bg-muted prose-pre:bg-muted prose-mark:bg-primary/30 prose-mark:text-foreground text-sm leading-relaxed";

/** Body padding for feed rows that sit beside {@link AdvisorAccentBar}. */
export const ANALYZE_FEED_ROW_BODY_CLASS = "flex-1 min-w-0 py-2 pr-2 pl-2.5";

export const DEFAULT_SCAN_STEPS = [
  "Reading image details",
  "Matching board instructions",
  "Identifying notable conditions",
  "Structuring observations",
  "Finalizing your insight",
] as const;

export const ADVISOR_SCAN_STEPS: Record<string, readonly string[]> = {
  site_safety: [
    "Scanning for fall and strike hazards",
    "Checking PPE and access paths",
    "Reviewing housekeeping and barriers",
    "Flagging visible risk signals",
    "Writing safety observations",
  ],
  workmanship: [
    "Inspecting finish and alignment",
    "Reviewing material handling",
    "Checking defects and overspill",
    "Assessing craft standards",
    "Preparing workmanship notes",
  ],
  analyze: [
    "Surveying overall site context",
    "Cross-checking diagnostic cues",
    "Separating facts from unknowns",
    "Prioritizing follow-up items",
    "Composing field diagnostics",
  ],
  execute: [
    "Reviewing methods on display",
    "Checking sequence and setup",
    "Spotting efficiency signals",
    "Noting coaching opportunities",
    "Drafting methods feedback",
  ],
  review: [
    "Evaluating completeness",
    "Reviewing quality indicators",
    "Checking documentation cues",
    "Weighing durability risks",
    "Summarizing evaluations",
  ],
};
